export class ItemTypeDTO {
  itemTypeId: string;
  itemTypeName: string;
  isActive: boolean;
}
